// Columns of the LP Pipeline (fundraising) table on the entity raise dashboard.
//
// `sortKey` must match a key of SalesforceFundraisingsService::SORTABLE_FIELDS in
// alps-be, which maps it to the SOQL field. Sorting is server-side because the
// table is paginated, so a column without a `sortKey` (Last Interaction Date, Action)
// is not sortable.
export const FUNDRAISING_COLUMNS = [
	{ label: 'Account', sortKey: 'account_name' },
	{ label: 'Investor Type', sortKey: 'investor_type' },
	{ label: 'Internal Coverage', sortKey: 'internal_coverage' },
	{ label: 'Active', sortKey: 'active' },
	{ label: 'Existing Investor', sortKey: 'existing_investor' },
	{ label: 'Commitment', sortKey: 'commitment' },
	{ label: 'Pipeline Status', sortKey: 'stage' },
	{ label: 'Anticipated Close Date', sortKey: 'anticipated_close_date' },
	{ label: 'Closing Round', sortKey: 'closing_round' },
	{ label: 'Last Interaction Date', sortKey: null },
	{ label: 'Action', sortKey: null },
];

export const FUNDRAISING_SORT_KEYS = FUNDRAISING_COLUMNS.filter(
	({ sortKey }) => sortKey
).map(({ sortKey }) => sortKey);
